var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,7.75a.75.75,0,0,0,0,1.5h6a.75.75,0,0,0,0-1.5Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,16.25a.25.25,0,0,0,.24-.2,7.48,7.48,0,0,1,.24-1c0-.11,0-.34-.33-.34H6a.75.75,0,0,0,0,1.5Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69,19.19A.26.26,0,0,0,9.45,19H3.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,3.5,5h11a.5.5,0,0,1,.5.5V9.58a.24.24,0,0,0,.3.24,19.85,19.85,0,0,1,2.47-.29A.25.25,0,0,0,18,9.28V3.5A1.5,1.5,0,0,0,16.5,2h-4a.27.27,0,0,1-.21-.12,3.82,3.82,0,0,0-6.58,0A.27.27,0,0,1,5.5,2h-4A1.5,1.5,0,0,0,0,3.5v17A1.5,1.5,0,0,0,1.5,22h8.94a.25.25,0,0,0,.21-.38A7.67,7.67,0,0,1,9.69,19.19Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.24,11.48c.09-.08,0-.23-.24-.23H6a.75.75,0,0,0,0,1.5h5a.26.26,0,0,0,.19-.1A8.63,8.63,0,0,1,12.24,11.48Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,11A6.5,6.5,0,1,0,24,17.5,6.51,6.51,0,0,0,17.5,11Zm3.27,5.2-2.9,3.88a1.52,1.52,0,0,1-1.2.6,1.5,1.5,0,0,1-1.06-.44l-1.5-1.5a.75.75,0,0,1,1.06-1.06L16.47,19a.24.24,0,0,0,.37,0l2.73-3.65a.75.75,0,0,1,1.05-.15A.74.74,0,0,1,20.77,16.2Z",
    style: {
      fill: "current"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.9e472a8629180a5b3c33580e5575c446.svg";
export { ForwardRef as ReactComponent };